import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, AttendanceIcon, Content, DashList, DataListWrap, Img, Tag, Tags, Td, TitleLeft } from './MissingTeacherReg.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import StudentThumbnail from '@components/StudentThumbnail';
import Missing from '@assets/svg/match/missing.svg';
import Late from '@assets/svg/match/late.svg';
import Attending from '@assets/svg/match/attending.svg';
import More_Icon from "@assets/svg/more.svg";
import Note_Icon from "@assets/svg/notes.svg";
import Profile_Icon from "@assets/svg/profile.svg";
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import fixedNumber from '@utils/fixedNumber';
import { AttendanceMap } from '@models/AttendanceType';
import { TagPill, TagPills } from '@components/Note/Message/Message.styled';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import Teams_Icon from "@assets/svg/teams.svg";
import S_Icon from "@assets/svg/s_icon.svg";
import { CheckBox, CheckboxIcon, DateContainer, FilterBox, FilterButton, FilterButtons, FilterDrop, FilterDropHead, FilterDropInput, FilterInfo, FilterInput, FilterItem, FilterReset, FilterText, QuickBtn } from '../SchoolLeader.styled';
import Tooltip from '@components/Tooltips/Tooltip';
import Tooltip_Icon from "@assets/svg/new_exclam1.svg";
import DateSelect from '../StudentDetails/DateSelect';
import { DateSelector, SubTitle } from '../StudentDetails/StudentDetails.styled';
import Cal_Icon from "@assets/svg/new_calendar.svg"
import { ShowabsenceOrAttendance } from '@utils/percentageTools';
import { GenerateExcelFile } from '../excel';
import { MoreTags } from '../NoteDetails/NoteDetails.styled';

interface IProps {

}

export const MissingTeacherReg = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      Excel()
    },
  }));

  const { client, settings, callNameSetting, filterDate, schoolViewRegistrations, schoolViewFilter, page, setPage, systemSettings } = useStore();
  const [sort, setSort] = useState({ type: 1, direction: false })
  const pageSize = 13;
  const i18n = useI18n();
  const tagsCount = useRef(0)
  const [missingReg, setMissingReg] = useState(null)
  const [loadingMissingReg, setLoadingMissingReg] = useState(true)

  useEffect(() => {
    GetData()
  }, []);

  const getFilteredMissingReg = () => {
    let missingRegTemp = JSON.parse(JSON.stringify(missingReg))
    missingRegTemp = missingRegTemp
      ?.filter(s => s.teacher_displayname?.toLowerCase().includes(schoolViewFilter.search10?.toLowerCase()) || s.coursedescription?.toLowerCase().includes(schoolViewFilter.search10?.toLowerCase()) || s.displayname.toLowerCase().includes(schoolViewFilter.search10?.toLowerCase()))

    return missingRegTemp
  }

  function getSortedMissingReg() {
    let missingTemp = getFilteredMissingReg()
    missingTemp = missingTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.teacher_displayname > b.teacher_displayname) return 1 * dir
          else if (a.teacher_displayname < b.teacher_displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.date > b.date) return 1 * dir
          else if (a.date < b.date) return -1 * dir
          else return 0
          break;
        case 2:
          if (a.coursedescription > b.coursedescription) return 1 * dir
          else if (a.coursedescription < b.coursedescription) return -1 * dir
          else return 0
          break;
        case 3:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
          break;
        case 4:
          if (a.starttime > b.starttime) return 1 * dir
          else if (a.starttime < b.starttime) return -1 * dir
          else return 0
          break;
        case 5:
          if (a.endtime > b.endtime) return 1 * dir
          else if (a.endtime < b.endtime) return -1 * dir
          else return 0
          break;
      }
    })
    return missingTemp
  }

  const GetData = async () => {
    setLoadingMissingReg(true)
    let result = await db.GetMissingRegistrations(90, null)
    setMissingReg(result)
    setLoadingMissingReg(false)
  }

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  function Excel() {
    let headers = [
      i18n.t("header-name"),
      i18n.t("date"),
      i18n.t("course"),
      i18n.t("filter-subjects"),
      i18n.t("header-starttime"),
      i18n.t("header-endtime"),
    ];

    let data = getSortedMissingReg()?.map(r => {
      let object = {}
      object[i18n.t("header-name")] = r.teacher_displayname;
      object[i18n.t("date")] = moment(r.date).format("DD-MM-YYYY");
      object[i18n.t("course")] = r.coursedescription;
      object[i18n.t("filter-subjects")] = r.displayname;
      object[i18n.t("header-starttime")] = moment(moment(r.date).format('YYYY-MM-DD') + " " + r.starttime).format('HH:mm');
      object[i18n.t("header-endtime")] = moment(moment(r.date).format('YYYY-MM-DD') + " " + r.endtime).format('HH:mm');
      return object;
    })

    GenerateExcelFile(i18n.t("sub-nav10").replace(/\s/g, '_') + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, moment().format('DD-MM-YYYY-HHmm'));
  }

  const getTextCount = () => {
    let count;
    let totalCount;

    count = getSortedMissingReg()?.length
    totalCount = missingReg?.length

    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }
  }

  return (<>
    <Content>
      <TitleLeft>
        <span>{i18n.t("sub-nav10")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>


      {loadingMissingReg ? <RainbowLoader /> : missingReg?.length > 0 ? <><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"}></td>
              <Td className={"width20"} onClick={() => handleSort(0)}>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td className={"width20"} onClick={() => handleSort(1)}>{i18n.t("date")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></Td>
              <Td className={"width20"} onClick={() => handleSort(2)}>{i18n.t("course")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></Td>
              <Td className={"width20"} onClick={() => handleSort(3)}>{i18n.t("filter-subjects")} <SortArrow sortActive={sort.type === 3} asc={sort.type === 3 && sort.direction === false} /></Td>
              <Td className={"width20"} onClick={() => handleSort(4)}>{i18n.t("header-starttime")} <SortArrow sortActive={sort.type === 4} asc={sort.type === 4 && sort.direction === false} /></Td>
              <Td className={"width20"} onClick={() => handleSort(5)}>{i18n.t("header-endtime")} <SortArrow sortActive={sort.type === 5} asc={sort.type === 5 && sort.direction === false} /></Td>
            </tr>
            {missingReg ? getSortedMissingReg()?.slice((page * pageSize - pageSize), pageSize * page).map((r, index) => {
              return <tr key={"registration_" + index}>
                <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={r?.username} src={r.teacher_id} /></Img></td>
                <td>{r.teacher_displayname}</td>
                <td>{moment(r.date).format('DD-MM-YYYY')}</td>
                <td>{r.coursedescription}</td>
                <td>{r.displayname}</td>
                <td>{moment(moment(r.date).format('YYYY-MM-DD') + " " + r.starttime).format('HH:mm')}</td>
                <td>{moment(moment(r.date).format('YYYY-MM-DD') + " " + r.endtime).format('HH:mm')}</td>
              </tr>
            }) : null}
          </tbody>
        </DashList>
      </DataListWrap>
        <Pagination pageSize={pageSize} count={getSortedMissingReg()?.length} currentPage={page} maxPage={Math.ceil(getSortedMissingReg()?.length / pageSize)} setPage={setPage} /></> : <EmptyBox Graphic={'documents'} marvin={true} text={i18n.t("no-filter-data")} />}
    </Content>
  </>);
});

export default MissingTeacherReg;